import React from "react";
import {useHistory} from "react-router";
import PropTypes from "prop-types";
import Banner from "./images/ff-background.png";
import ApprovedIcon from "./images/approved-icon.png";
import styles from "./styles.css";
import CARS24Logo from "./images/logo.svg";
// import PercentIcon from "./images/percent-icon.svg";
// import PrivacyIcon from "./images/privacy-icon.svg";
import { getPreApprovedAmount, getffFooterText } from "../../../utils/helpers/get-pre-approved-amount";
import PercentageIcon from "./images/percentage.svg";
import OurRateMatchPromisePopup from "../our-rate-match-promise-popup/component";

const PreApprovedClpBannerVariantB = ({ maxPermissibleRepaymentPerWeek, firstName, absolutePermissibleLoanAmount, preApprovalFirstName }) => {
    const history = useHistory();
    const [isRateMatchPopupVisible, setIsRateMatchPopupVisible] = React.useState(false);

    const handleKnowMoreClick = () => {
        history.push("/cars24-finance");
    };

    const handleBestInterestClick = () => {
        setIsRateMatchPopupVisible(true);
    };

    return (
        <React.Fragment>
            <div styleName={"styles.preapprovedWrapper"}>
                <img src={Banner} alt="pre approved banner" styleName={"styles.backgroungBanner"}/>
                <div styleName={"styles.preapprovedIconWrappers"}>
                    <img src={ApprovedIcon} alt="approved icon" styleName={"styles.preapprovedIcon"} />
                    <div styleName={"styles.detailsWrapper"}>
                        <p styleName={"styles.textStyle1"}>Congratulations {preApprovalFirstName || firstName || ""}!</p>
                        <p styleName={"styles.textStyle2"}>You’ve been pre-approved for</p>
                        <p styleName={"styles.textStyle3"}>finance <span>upto</span> <span>{getPreApprovedAmount(absolutePermissibleLoanAmount, maxPermissibleRepaymentPerWeek)}</span></p>
                        <div styleName={"styles.perksWrapper"}>
                            {/* <div styleName={"styles.perks"}>
                            <img src={PercentIcon} alt="percent icon" />
                            <p>100% online finance process</p>
                        </div>
                        <div styleName={"styles.perks"}>
                            <img src={PrivacyIcon} alt="Privacy icon" />
                            <p>User privacy and data confidentiality</p>
                        </div> */}
                            <img  src={PercentageIcon} alt="percent icon"  />
                            <button styleName={"styles.bestInterest"} onClick={handleBestInterestClick}>{"Best interest rates>>"}</button>
                        </div>
                        <p styleName={"styles.knowMore"} onClick={handleKnowMoreClick}>Know more about finance </p>
                    </div>
                </div>
                <img src={CARS24Logo} alt="CARS24 logo" styleName={"styles.logo"} />
                <div styleName={"styles.flexRow"}>
                    <p styleName={"styles.textStyle4"}>{getffFooterText(absolutePermissibleLoanAmount, maxPermissibleRepaymentPerWeek)}</p>
                </div>
            </div>
            {isRateMatchPopupVisible && <OurRateMatchPromisePopup setIsRateMatchPopupVisible={setIsRateMatchPopupVisible} isRateMatchPopupVisible={isRateMatchPopupVisible} />}
        </React.Fragment>
    );
};

PreApprovedClpBannerVariantB.propTypes = {
    maxPermissibleRepaymentPerWeek: PropTypes.number,
    firstName: PropTypes.string,
    absolutePermissibleLoanAmount: PropTypes.number,
    preApprovalFirstName: PropTypes.string
};

export default PreApprovedClpBannerVariantB;
